import styled from "styled-components";
import { designTokens, getTypography } from "styles/designTokens";

interface LoginInputTextStyleProps {
  error?: boolean;
}

interface LoginButtonStyleProps {
  disabled: boolean;
}

export const PageContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 16px;
`;


export const FormContainer = styled.form`
  width: 100%;
  max-width: 380px;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid rgba(230, 230, 255, 0.3);
  backdrop-filter: blur(12px);
  border-radius: 16px;
  padding: 32px 32px 48px 32px;
  box-shadow: 0 8px 32px rgba(92, 110, 255, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;


export const LoginInputTextStyle = styled.input<LoginInputTextStyleProps>`
  width: 100%;
  height: 44px;
  padding: 10px 14px;
  border-radius: 6px;
  border: 1px solid ${({ error }) => (error ? "#ff4d4f" : "#e5e5e5")};
  background: #fafafa;
  color: ${designTokens.colors.font.primary};
  ${getTypography("korean", "body3")};
  transition: border 0.15s ease, background 0.15s ease;

  &::placeholder {
    color: #aaa;
  }

  &:hover {
    border-color: #ccc;
  }

  &:focus {
    outline: none;
    border-color: #5c6eff;
    background: #fff;
    box-shadow: 0 0 0 3px rgba(92, 110, 255, 0.08);
  }
`;

export const LoginButtonStyle = styled.button<LoginButtonStyleProps>`
  width: 100%;
  height: 46px;
  border-radius: 6px;
  border: none;
  background: ${({ disabled }) => (disabled ? "#e6e8fa" : "#5c6eff")};
  color: white;
  font-weight: 500;
  font-size: 15px;
  transition: background 0.2s ease;
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};

  &:hover:not(:disabled) {
    background: #4b5eff;
  }
`;

export const HelperLinks = styled.div`
  ${getTypography("korean", "body3")}
  font-weight: 600;
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 0 8px;

  a {
    color: #8a8a8a;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
      color: #5c6eff;
    }
  }
`;

export const BackgroundGlow = styled.div`
  position: absolute;
  width: 600px;
  height: 600px;
  background: radial-gradient(
    circle,
    rgba(92, 110, 255, 0.15),
    transparent 70%
  );
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 0;
  pointer-events: none;
`;

export const SignupSection = styled.div`
  width: 100%;
  max-width: 400px;
  text-align: center;

  p {
    ${getTypography("korean", "body4")}
    color: #444;
    margin-bottom: 12px;
  }

  button {
    ${getTypography("korean", "body3")}
    background: #5c6eff;
    box-shadow: 0 4px 16px rgba(92, 110, 255, 0.18);
    color: white;
    font-weight: 700;
    border: none;
    border-radius: 8px;
    padding: 10px 20px;
    cursor: pointer;
    transition: background 0.2s ease;

    &:hover {
      background: #4b5eff;
    }
  }
`;

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: linear-gradient(to right, transparent, #e8eaff, transparent);
  margin: 8px 0;
`;